import { formatEnrollmentDeadline } from '../format/formatCohortDate'
import type {
  CohortConfig,
  CohortContent,
  EnrollmentStateResult,
} from '../types'

export type StateCopyView =
  | { kind: 'join'; label: string; deadline: string }
  | { kind: 'notify'; label: string }

export const getStateCopy = (
  content: CohortContent,
  config: CohortConfig,
  enrollment: EnrollmentStateResult,
): StateCopyView => {
  if (!('deadline' in enrollment)) {
    return { kind: 'notify', ...content.enrollmentStates[enrollment.state] }
  }

  const { label, deadline } = content.enrollmentStates[enrollment.state]

  return {
    kind: 'join',
    label,
    deadline: deadline[enrollment.urgency].replace(
      '{{date}}',
      formatEnrollmentDeadline(enrollment.deadline, config.timezone),
    ),
  }
}
